import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import ExerciseForm from '../forms/exercise-form';

type DialogProps = {
  id?: number
  isOpen: boolean
  closeDialog: () => void
  updateList?: () => void
}

export function DialogCreateExercise({ isOpen = false, closeDialog, updateList }: DialogProps) {


  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-4xl">
        <DialogHeader className="border-acelerafit-gray-dark">
          <DialogTitle className="text-acelerafit-green-300">Exercício</DialogTitle>
          <DialogDescription>Criação</DialogDescription>
        </DialogHeader>
        <ExerciseForm
          closeDialog={closeDialog}
          updateList={updateList}
        />
        <DialogFooter className="sm:justify-end w-148">
          <Button
            onClick={() => closeDialog()}
            className="bg-acelerafit-green-300 shadow-2xl hover:bg-acelerafit-green-300 hover:opacity-85 transition-all"
          >
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}